import * as types from './types';
import createReducer from '../../createReducer';

const initialState = {
  bh_times: [],
  loading: false,
  currentId: null,
  current: {
    name: '',
    description: '',
    error_message: '',
    bh_rules: [],
  },
  fetchedCreateBH: false,
  fetchedOverwriteBH: false,
  associatedVehileGroups: [],
  associatedVehileGroupsPagination: {},
};

const businessHoursReducer = createReducer(initialState)({
  [types.FETCH_CREATE_BH_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      fetchedCreateBH: false,
    };
  },
  [types.FETCH_CREATE_BH_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      currentId: payload.id,
      fetchedCreateBH: true,
    };
  },
  [types.FETCH_CREATE_BH_FAILED]: (state) => {
    return {
      ...state,
      loading: false,
      fetchedCreateBH: false,
    };
  },
  [types.FETCH_OVERWRITE_BH_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      fetchedOverwriteBH: false,
    };
  },
  [types.FETCH_OVERWRITE_BH_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      currentId: payload.id,
      fetchedOverwriteBH: true,
    };
  },
  [types.FETCH_OVERWRITE_BH_FAILED]: (state) => {
    return {
      ...state,
      loading: false,
      fetchedOverwriteBH: false,
    };
  },
  [types.FETCH_ASSOCIATED_VEHICLE_GROUPS_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
    };
  },
  [types.FETCH_ASSOCIATED_VEHICLE_GROUPS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      associatedVehileGroups: payload.data,
      associatedVehileGroupsPagination: payload.pagination,
    };
  },
  [types.FETCH_ASSOCIATED_VEHICLE_GROUPS_FAILED]: (state) => {
    return {
      ...state,
      loading: false,
    };
  },
  [types.FETCH_BH_BY_ID_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
    };
  },
  [types.FETCH_BH_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      current: payload,
    };
  },
  [types.FETCH_BH_BY_ID_FAILED]: (state) => {
    return {
      ...state,
      loading: false,
    };
  },
  [types.FETCH_UPDATE_BH_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      fetchingUpdateBH: true,
      fetchedUpdateBH: false,
    };
  },
  [types.FETCH_UPDATE_BH_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      current: payload,
      fetchingUpdateBH: false,
      fetchedUpdateBH: true,
    };
  },
  [types.FETCH_UPDATE_BH_FAILED]: (state) => {
    return {
      ...state,
      loading: false,
      fetchingUpdateBH: false,
      fetchedUpdateBH: false,
    };
  },
  [types.FETCH_BUSINESS_HOURS_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
    };
  },
  [types.FETCH_BUSINESS_HOURS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      bh_times: payload,
    };
  },
  [types.FETCH_BUSINESS_HOURS_FAILED]: (state) => {
    return {
      ...state,
      loading: false,
    };
  },
  [types.RESET_BH]: (state) => {
    return {
      ...state,
      current: {
        name: '',
        description: '',
        error_message: '',
        bh_rules: [],
      },
      loading: false,
      fetchedCreateBH: false,
      fetchedOverwriteBH: false,
    };
  },
  [types.UPDATE_CURRENT_BUSINESS_HOURS]: (state, { payload }) => {
    return {
      ...state,
      current: {
        ...state.current,
        ...payload,
      },
    };
  },
});

export default businessHoursReducer;
